
<template>
  <div  class="pc_aboutgoods">
    <ul v-if="tableData.list.length>0" class="ulList">
      <li class="" v-for="(item,index) in tableData.list" :key="index">
        <div class="left">
          <img v-lazy="item.corplogo_cn" alt="" />
        </div>
        <div class="center">
          <div class="userInformation">
            <p class="h7" @click.stop="exhjump(item)">
              {{item.corpname_cn}}
            </p>
            <p>展商范围：{{item.exrange_cn}}</p>
            <p>展馆/展位号：{{item.booth}}</p>
          </div>
          <div class="aboutContent">
            <div>
              <p class="title">
                <span>标题：</span>
                <!-- {{item.title}}   -->
              </p>
              <!-- <div class="hoverAccording">
                <span class="sanjiao"></span>
                {{item.title}} </div> -->
            </div>
            <p >
              <span>预约时间：</span>
              {{item.date}}</p>
            <div class="con">
              <p>
                <span>内容：</span>
                <el-tooltip :content="item.connet" placement="bottom" effect="light">
                  <span>{{item.connet}}</span>
                </el-tooltip>
              </p>
              <!-- <div class="hoverAccording">
                <span class="sanjiao"></span>
                 {{item.connet}}
              </div> -->
            </div>
          </div>
          <p class="time">{{item.ctime}}</p>
        </div>
        <div class="right">
          <el-button :class="item.status*1==0?'reception ':'reception btn'" disabled>{{item.status*1==0?"待确认":"已确认"}}</el-button>
          <!-- <span>取消</span> -->
          <el-popconfirm
            v-if="item.status*1==0"
            title="确定要取消吗？"
            @onConfirm='isCollect(item.id)'
          >
            <el-button class="del" type="danger" slot="reference">取消</el-button>
          </el-popconfirm>
        </div>
      </li>
    </ul>
    <div v-else class="peomp_con">
      <div class="prompt_img">
        <img v-lazy="hrefurl+'/public/icon/without.png'" alt="" />
      </div>
      <p>暂无邀约</p>
    </div>
    <el-pagination
      v-if="tableData.listnum>tableData.pagelistnum"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="tableData.thispage"
      :page-size="tableData.pagelistnum"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="上一页"
      next-text="下一页"
      :total="tableData.listnum * 1"
    >
    </el-pagination>

    <!-- <template>
  <div class="pc_aboutgoods">
    <AboutList :tableData="tableData" name="取消预约" @isCollect='isCollect' @init='init'/>
  </div>
</template> -->
  </div>
</template>

<script>
// import AboutList from "../../../../components/pc/aboutList";
import { reqMyCorpApp, reqCorpAppOff } from "../../../../api";
export default {
  components:{
    // AboutList,
  },
  data(){
    return{
      tableData:{
        listnum: "15",
        pagelistnum: 20,
        prompt:"确定要取消预约吗？",
        list:[
          // {
          //   area:"210",
          //   booth: "E3501",
          //   corplogo_cn: "https://e.cippe.com.cn/upload/corplogo/1594178011.jpg",
          //   corpname_cn: "南阳二机石油装备集团股份有限公司",
          //   corpname_en: "RG PETRO-MACHINERY GROUP CO., LTD",
          //   exrange_cn: "公司产品包括橇装钻机、车装钻机、拖挂钻机、修井机、海洋钻修装备、水井钻机、测井装备、石油特种设备、顶驱、固控及泥浆循环设备、油井测试设备、专用车辆、顶部驱动装置、泥浆泵、提升及旋转钻井设备及配件等12大系列200多个品种",
          //   exrange_en: "RG has complete petroleum product system which cover 12 varieties with over 200 products including skid-mounted drilling rigs, truck-mounted drilling rigs, trailer-mounted drilling rigs, offshore workover equipment, water well drilling rig, solid control system, well logging equipment, petroleum special vehicles, top drive system, mud pump system.",
          //   id: "11134",
          //   uid: "9009",
          // },
          // {
          //   area: "205",
          //   booth: "H1000",
          //   corplogo_cn: "https://e.cippe.com.cn/upload/corplogo/1594778094.png",
          //   corpname_cn: "南阳市南石力天石油设备有限公司",
          //   corpname_en: "NSLT PETROLEUM EQUIPMENT CO., LTD",
          //   exrange_cn: "石油修井机、煤层气钻机、水井钻机、井口设备、动力单元、液压件等系列产品",
          //   exrange_en: "",
          //   id: "11341",
          //   uid: "9098",
          // }
        ]
      }
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    handleCurrentChange(a){//当前页改变时
      // 调用请求接口
      this.init(a)
    },

    handleSizeChange(){//每页条数改变时  备用动态条数
    },
    async init(p=1){//已预约展商
      const response = await reqMyCorpApp(p)
      if (response.code*1==2) {//请求成功 有数据
        this.tableData={
          listnum:response.listnum,
          pagelistnum:response.pagelistnum,
          list:response.reslist
        }
      }else if (response.code*1==0) {//未登录
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"登录失效，请重新登录...")
      }else if(response.code*1==1){//没有预约
      }
    },
    async isCollect(id){//修改预约状态
      const response = await reqCorpAppOff(id)
      if (response.code==3) {
        let index = this.tableData.list.findIndex(item=>item.id==id)
        if (index>=0) {
          let {tableData} =this
          tableData.list.splice(index,1)
          this.tableData = tableData
        }
        this.success(this,'取消预约成功！')
      }else{
        this.err(this,'请求失败，请重新尝试。。。')
      }
    },

    exhjump(item){//跳转展商详情
      this.$router.push('/exhibitor/details/'+item.offid+'/'+item.ocid)
    }
  }
}

</script>

<style scoped>
  .pc_aboutgoods{
    width: 100%;
  }
  .ulList{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding:10px 4px;
  }
  .ulList>li{
    /* min-width: 330px;
    max-width: 430px; */
    /* width: 48%; */
    width: 100%;
    display: flex;
    /* justify-content: space-between; */
    background-color: #fafafa;
    padding-left: 10px;
    box-sizing: border-box;
    vertical-align: middle;
    margin-bottom: 20px;
    font-size: 12px;
    position: relative;
    border-radius: 5px;
    /* overflow: hidden; */
    min-height: 120px;

  }
  .ulList .left{
    width: 100px;
    vertical-align: middle;
    padding: 10px 0;
  }
  .ulList .center{
    position: relative;
    vertical-align: middle;
    /* min-width: 240px; */
    padding: 10px 10px 10px 20px;
    display: flex;
    width: calc(100% - 200px);
  }
  .userInformation{
    width: 50%;
  }
  .aboutContent{
    width: 50%;
  }
  .aboutContent>div{
    position: relative;
  }
  .aboutContent p span{
    color: #008baf;
  }
  .ulList .center p{
    line-height: 24px;
    font-size: 14px;
  }
  .ulList .center .userInformation p{
    line-height: 30px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ulList .center .aboutContent .title{
    position: relative;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 0;
  }
  
  .ulList .center .h7{
    font-size: 18px;
    vertical-align: bottom;
    cursor: pointer;
  }
  .ulList .center .h7:hover{
    color: #008baf;
  }
  .center .h7 span{
    vertical-align: bottom;
    font-size: 14px;
    margin-left: 6px;
  }
  .ulList .center .time{
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
  .ulList .center .aboutContent .con>p{
    max-height: 50px;
    height: auto;
    overflow: hidden;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  /* .ulList .center .hoverAccording{
    position: absolute;
    display: none;
    z-index: 9;
    background-color: #f5f5f5;
    border-radius: 4px;
    border: 1px solid #aaa;
    box-shadow: 0 3px 3px #d0cdcd;
    top: 30px;
    max-width: 300px;
    min-width: 300px;
    padding: 4px 6px;
    line-height: 20px;
  } */
  /* .sanjiao{
    position: absolute;
    top: -20px;
    left: 40px;
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #aaa;
    border-left: 10px solid transparent;
  } */
  .ulList .center .aboutContent>div:hover div,
  .ulList .center .aboutContent>div:hover div{
    display: block;
  }


  .ulList .right{
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    /* background-color: #008baf; */
    color: white;
    font-weight: 600;
    vertical-align: middle;
    min-width: 40px;
    text-align: center;
    height: auto;
    font-size: 16px;
    /* padding-top: calc(50% - 7px); */
    height: 120px;
    box-sizing: border-box;
    line-height: 60px;
  }
  .ulList .reception{
    width: 80px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    color: #008baf;
    background:none;
    border: none;
  }
  .ulList .btn{
    color: #333;
  }
  .ulList .del{
    background-color: #008baf;
    /* height: 100%;
    width: 100%; */
    border:none;
    /* padding: 0; */
    transition: all .5s;
    border-radius: 5px;
    cursor: pointer;
    width: 80px;
    padding-right: 0;
    padding-left: 0;
    text-align: center;
  }
  .ulList .del:hover{
    background-color:#f08300; 
  }

  .prompt_img{
    width: 200px;
    margin: 100px auto 0;
    opacity: .8;
  }
  .peomp_con>p{
    font-size: 14px;
    text-align: center;
    line-height: 24px;
    padding-top: 10px;
  }
  .goods_jump{
    color: #008baf;
    cursor: pointer;
  }

  .pc_aboutgoods>>>.el-pagination{
    padding: 40px 0 20px;
    text-align: center;
  }
  .pc_aboutgoods>>>.el-pager li,
  .pc_aboutgoods>>>.el-pagination .btn-next, 
  .pc_aboutgoods>>>.el-pagination .btn-prev{
    background-color: transparent;
  }


  @media (min-width: 768px) and (max-width: 900px) {
    .ulList .center{
      display: block;
    }
    .aboutContent, .userInformation{
      width: 100%;
    }
    .ulList .center .aboutContent .title{
      display: none;
    }
  }

</style>